module.exports = {
  theme: {
    extend: {
      fontFamily: {
        sans: ['system-ui', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'sans-serif'],
      },
      colors: {
        accent: {
          DEFAULT: '#5b3ea6',
          soft: 'rgba(91, 62, 166, 0.08)',
          dark: '#4a3290',
        },
      },
    },
  },
};
